var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv2-1.jpg"
    }
  }, [_c('h2', {
    staticClass: "font-weight-thin",
    attrs: {
      "data-aos": "fade-down",
      "data-aos-duration": "1200"
    }
  }, [_vm._v("영업 실적은 물론,")]), _c('div', {
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1400"
    }
  }, [_c('h2', {
    staticClass: "font-weight-bold ani--fill"
  }, [_vm._v("브랜드의 가치까지 전달합니다.")])])]), _c('section', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScrollFixedA,
      expression: "onScrollFixedA"
    }],
    staticClass: "page-section--fixed page-section--fixed1"
  }, [_c('div', {
    staticClass: "fixed-contents"
  }, [_c('div', {
    staticClass: "fixed-bg"
  }), _c('v-container', [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "tit-wrap color-white"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v("서비스 소개")])]), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScrollFixedD,
      expression: "onScrollFixedD"
    }],
    staticClass: "business-intro"
  }, [_c('v-divider', {
    staticClass: "border-2 mb-18 mb-lg-36",
    staticStyle: {
      "border-color": "rgba(255, 255, 255, 0.3)"
    }
  }), _c('v-row', {
    staticClass: "ma-lg-0 text-center business-intro-items"
  }, [_c('v-col', {
    staticClass: "pa-lg-0 mb-n8 business-intro-item",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-point line-height-1 mb-4 mb-lg-10"
  }, [_vm._v(" Subscription ")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-white"
  }, [_vm._v(" 서비스 홍보 및 구독자 확보 ")])]), _c('v-col', {
    staticClass: "pa-lg-0 mb-n8 business-intro-item",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-point line-height-1 mb-4 mb-lg-10"
  }, [_vm._v(" Commercial ")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-white"
  }, [_vm._v(" 국내외 제품 세일즈 및 홍보 ")])]), _c('v-col', {
    staticClass: "pa-lg-0 business-intro-item",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-point line-height-1 mb-4 mb-lg-10"
  }, [_vm._v(" Fundraising ")]), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-white"
  }, [_vm._v(" NGO 단체 후원자 유치 ")])])], 1)], 1)]), _c('section', {
    staticClass: "section pt-0"
  }, [_c('div', {
    staticClass: "mb-50"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/business/introduction/s1-img1.jpg",
      "alt": ""
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "mt-md-180 mt-lg-250 pl-md-20 pl-xl-66"
  }, [_c('h4', {
    staticClass: "bar-text bar-text--lg color-white mb-6 mb-lg-12"
  }, [_vm._v(" 서비스 홍보 및 구독자확보 ")]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 다양한 국가에서 25년간 축적한 경험과 노하우를 바탕으로 자체 세일즈 팀이 없거나, 보다 나은 영업 실적을 원하는 고객사의 제품 세일즈, 서비스 홍보, 구독자 확보를 전문적으로 대행합니다. ")])])])], 1)], 1), _c('div', {
    staticClass: "mb-50 mb-lg-100"
  }, [_c('v-row', {
    staticClass: "flex-column-reverse flex-md-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "pr-md-20 pr-xl-66"
  }, [_c('h4', {
    staticClass: "bar-text bar-text--lg color-white mb-6 mb-lg-12"
  }, [_vm._v(" 국내외 제품 세일즈 및 홍보 ")]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 세일즈웍스의 세일즈 & 구독 대행 서비스는 영업 전문가인 브랜드 홍보대사의 대면 영업을 통해 잠재고객 한 명 한 명에게 맞춤형 홍보가 가능합니다. 구독자 확보에 최적화된 세일즈웍스만의 독자적인 서비스는 구독경제 시대에 더욱 주목 받고 있습니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "300"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mt-md-50 mt-lg-100",
    attrs: {
      "src": "/images/sub/business/introduction/s1-img2.jpg",
      "alt": ""
    }
  })])], 1)], 1), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/business/introduction/s1-img3.jpg",
      "alt": ""
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "mt-md-180 mt-lg-250 pl-md-20 pl-xl-66"
  }, [_c('h4', {
    staticClass: "bar-text bar-text--lg color-white mb-6 mb-lg-12"
  }, [_vm._v(" NGO 단체 후원자 유치 ")]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" NGO 단체에 특화된 서비스를 위한 펀드레이징 전문 브랜드, 서포트웍스는 전문 펀드레이저와 함께 NGO의 가치와 의미를 전달하고 후원자를 유치합니다. ")])])])], 1)], 1)])])], 1)]), _c('section', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScrollFixedC,
      expression: "onScrollFixedC"
    }],
    staticClass: "section business-banner text-center color-white w-100 font-size-32 font-size-md-46 font-size-lg-60 line-height-13",
    staticStyle: {
      "background-color": "#000"
    }
  }, [_c('v-container', [_c('h3', {
    staticClass: "font-weight-thin fade-down"
  }, [_vm._v("공감을 이끌어내는 가장 좋은 방법,")]), _c('div', {
    staticClass: "fade-right"
  }, [_c('h3', {
    staticClass: "ani--fill--scr color-white"
  }, [_vm._v("Face to Face")])])])], 1), _c('section', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScrollFixedB,
      expression: "onScrollFixedB"
    }],
    staticClass: "page-section--fixed page-section--fixed2"
  }, [_c('div', {
    staticClass: "fixed-contents"
  }, [_c('div', {
    staticClass: "fixed-bg"
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap color-white"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v("Face to Face만이 줄 수 있는 가치")])]), _c('div', {
    staticClass: "mb-50"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/business/introduction/s2-img1.jpg",
      "alt": ""
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "mt-md-180 mt-lg-250 pl-md-20 pl-xl-66"
  }, [_c('h4', {
    staticClass: "bar-text bar-text--lg color-white mb-6 mb-lg-12"
  }, [_vm._v(" 미디어로 전하기 어려운 가치 전달 ")]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 넘쳐나는 디지털 정보 속에 소비자들은 믿을 수 있는 정보, 사람의 온기가 느껴지는 경험을 필요로 합니다. 세일즈웍스는 의뢰받은 상품 또는 서비스에 대한 깊은 이해를 바탕으로 고객과 직접 대화하며 소통하는 대면 캠페인을 기획하고 진행합니다. ")])])])], 1)], 1), _c('div', {
    staticClass: "mb-50 mb-lg-100"
  }, [_c('v-row', {
    staticClass: "flex-column-reverse flex-md-row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "pr-md-20 pr-xl-66"
  }, [_c('h4', {
    staticClass: "bar-text bar-text--lg color-white mb-6 mb-lg-12"
  }, [_vm._v(" 1:1 맞춤형 서비스 설계 ")]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 브랜드 홍보대사는 담당하는 제품 및 서비스의 전문가가 될 때까지 체계적인 교육을 받고 홍보를 통해 긍정적인 브랜드 이미지를 전달합니다. 대화를 통해 호감을 형성하고 고객 한 명 한 명에게 신뢰도 높은 정보를 제공하기 때문에 판매 성과 및 서비스 구독 전환율이 높습니다. ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "300"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mt-md-50 mt-lg-100",
    attrs: {
      "src": "/images/sub/business/introduction/s2-img2.jpg",
      "alt": ""
    }
  })])], 1)], 1), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": "/images/sub/business/introduction/s2-img3.jpg",
      "alt": ""
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "300"
    }
  }, [_c('div', {
    staticClass: "mt-md-180 mt-lg-250 pl-md-20 pl-xl-66"
  }, [_c('h4', {
    staticClass: "bar-text bar-text--lg color-white mb-6 mb-lg-12"
  }, [_vm._v(" 고객의 직접적인 피드백 수집 ")]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" 서포트웍스의 펀드레이저는 전문 펀드레이저 양성 과정, 온라인 프로그램, NGO 단체의 교육 등을 거쳐 확고한 윤리관과 책임감으로 NGO의 가치를 전달합니다. ")])])])], 1)], 1)])], 1)])]), _c('section', {
    staticClass: "section color-white",
    staticStyle: {
      "background-image": "url(/images/sub/business/introduction/s3-bg.jpg)",
      "background-position": "center bottom",
      "background-size": "100% auto",
      "background-color": "#000"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v("산업분야")])])]), _c('div', {
    staticClass: "business-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "business-slide__inner"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mb-12 mb-lg-36",
    attrs: {
      "src": "/images/sub/business/introduction/s3-img1.jpg",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14"
  }, [_vm._v(" IT ")]), _c('p', {
    staticClass: "page-text--sm color-grey-d"
  }, [_vm._v(" 플랫폼 비즈니스 ")])]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mb-12 mb-lg-36",
    attrs: {
      "src": "/images/sub/business/introduction/s3-img2.jpg",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14"
  }, [_vm._v(" 금융 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-d"
  }, [_vm._v(" 카드, 보험, 금융상품 ")])]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mb-12 mb-lg-36",
    attrs: {
      "src": "/images/sub/business/introduction/s3-img3.jpg",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14"
  }, [_vm._v(" 서비스 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-d"
  }, [_vm._v(" 교육, 통신, 미디어 ")])]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mb-12 mb-lg-36",
    attrs: {
      "src": "/images/sub/business/introduction/s3-img4.jpg",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14"
  }, [_vm._v(" 펀드레이징 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-d"
  }, [_vm._v(" NGO, NPO, 자선단체 ")])]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mb-12 mb-lg-36",
    attrs: {
      "src": "/images/sub/business/introduction/s3-img5.jpg",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14"
  }, [_vm._v(" 소비재 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-d"
  }, [_vm._v(" 화장품, 생활용품, 차량용품 ")])]), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('img', {
    staticClass: "d-block w-100 mb-12 mb-lg-36",
    attrs: {
      "src": "/images/sub/business/introduction/s3-img6.jpg",
      "alt": ""
    }
  }), _c('h5', {
    staticClass: "tit-txt line-height-1 font-weight-bold mb-6 mb-lg-14"
  }, [_vm._v(" 에너지 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-d"
  }, [_vm._v(" 지속가능 에너지 솔루션 ")])])], 1)], 1)])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }